export default __webpack_public_path__ + "static/in-browser-apps-preview-20fa384eda18c69e454493132649641e.png";